export default __webpack_public_path__ + "static/media/avatar_unicorn4.eaf919de.mp3";